import { useEffect, useState } from "react";
import { getLang, t as tr } from "../i18n";

export default function useLang() {
  const [lang, setLang] = useState(getLang());
  useEffect(() => {
    const handler = () => setLang(getLang());
    window.addEventListener("langchange", handler);
    return () => window.removeEventListener("langchange", handler);
  }, []);
  const t = (key) => tr(key, lang);
  return { lang, t };
}
